import { CellContext } from '@tanstack/react-table'
import clsx from 'clsx'

import { Log, MandatoryLogInformation } from '@/types/logs'
import { checkBulkCurtailmentValues } from '@/modules/CombinedLogs/helpers/checkBulkCurtailmentValues'
import { MissingInfo } from './MissingInfo'

import styles from '../../../ui/CombinedLogs.module.scss'

interface Props extends CellContext<Log, string> {
    isDataLoading: boolean
    getElementAttributes: ({
        className,
        isOriginalTrip,
    }: {
        className?: string | undefined
        isOriginalTrip: boolean
    }) => {
        className: string
        style:
            | {
                  height: string
              }
            | {
                  height?: undefined
              }
    }
}

const getDirection = (log: Log): string => {
    const locationFrom = log.locationFrom || ''
    const locationTo = log.locationTo || ''

    if (locationFrom.includes('out') && locationTo.includes('out')) {
        return 'out'
    }

    if (locationFrom.includes('in') && locationTo.includes('in')) {
        return 'in'
    }

    return ''
}

export const Trip = ({ getElementAttributes, row, getValue }: Props) => {
    const value = getValue()

    const isBulkCurtailmentLog = !!row.original.bulkCurtailment

    return (
        <div>
            <div
                {...getElementAttributes({
                    isOriginalTrip: !!row.original.originalTrip,
                })}
            >
                {value ? (
                    isBulkCurtailmentLog ? (
                        `${value}${row.original.bulkCurtailment?.tripTo ? `-${row.original.bulkCurtailment?.tripTo}` : ''} ${isBulkCurtailmentLog ? getDirection(row.original) : ''}`
                    ) : (
                        `${value}${row.original.rtnTrips.length ? `/${row.original.rtnTrips.map((trip) => trip.trip).join(',')}` : ''}`
                    )
                ) : (
                    <MissingInfo label="trip" log={row.original} field={MandatoryLogInformation.Trip} />
                )}
            </div>

            {row.original.originalTrip && row.original.originalTrip.trip && (
                <div className={styles.originalRoutesFormContainer}>
                    <p>{`${row.original.originalTrip.trip}${row.original.originalTrip.rtnTrips && row.original.originalTrip.rtnTrips.length ? `/${row.original.originalTrip.rtnTrips.map((trip) => trip.trip).join(',')}` : ''}`}</p>
                </div>
            )}

            {row.original.bulkCurtailment && checkBulkCurtailmentValues(row.original) && (
                <div className={clsx(styles.originalRoutesFormContainer, styles.greyInput)}>
                    <span>to</span>
                </div>
            )}
        </div>
    )
}
